<template>
    <v-chip class="status-chip" small label :color="resolved.color" :outlined="outlined"
        :dark="!outlined && resolved.darkText" :light="!outlined && !resolved.darkText">
        <v-icon v-if="icon" left x-small>{{ icon }}</v-icon>{{ text }}
    </v-chip>
</template>
<script>
import { resolveChip, activeChip } from '@/utils/statusTones';

/**
 * Chip de estado para celdas de tabla: un dato, no un botón.
 *
 *   <StatusChip :active="!item.eliminado" />                       // Activo / Inactivo
 *   <StatusChip :active="item.activa" active-text="Activa" inactive-text="Cancelada" />
 *   <StatusChip label="Emitida" tone="pending" />
 *   <StatusChip :label="item.forma" :tone="tone" outlined />       // forma de pago
 *   <StatusChip :label="item.tipo.nombre" :color="item.tipo.color" /> // color del backend
 *
 * Tonos (utils/statusTones.js): success, danger, warning, info, pending,
 * neutral. Un `color` explícito gana sobre el tono. El estado nunca va solo
 * en color: siempre lleva texto, y opcionalmente un `icon`.
 *
 * Todo lo que depende de Vuetify (tamaño, `label`, tinta clara u oscura) vive
 * aquí, así que migrar a Vuetify 3 (`rounded`, `variant`) toca solo este archivo.
 */
export default {
    name: 'StatusChip',
    props: {
        label: { type: String, default: '' },
        tone: { type: String, default: 'neutral' },
        // Color de Vuetify o del catálogo del backend; gana sobre `tone`.
        color: { type: String, default: '' },
        outlined: { type: Boolean, default: false },
        // Icono opcional de Font Awesome (`fas fa-check-circle`).
        icon: { type: String, default: '' },
        // Atajo Activo / Inactivo: con él, `label` y `tone` se ignoran.
        active: { type: Boolean, default: null },
        activeText: { type: String, default: 'Activo' },
        inactiveText: { type: String, default: 'Inactivo' }
    },
    computed: {
        preset() {
            return this.active === null
                ? null
                : activeChip(this.active, { activeText: this.activeText, inactiveText: this.inactiveText });
        },
        text() {
            return this.preset ? this.preset.label : this.label;
        },
        resolved() {
            return resolveChip({ tone: this.preset ? this.preset.tone : this.tone, color: this.color });
        }
    }
};
</script>
<style scoped>
.status-chip {
    font-weight: 500;
    letter-spacing: 0;
}
</style>
